import React from "react";
import { IconBaseProps } from "react-icons";

export const UploadSVG: React.FC<IconBaseProps> = ({ fill = "currentColor", size = 26 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 26 26"
    fill={fill}
    fillRule="evenodd"
  >
    <path d="M21.325 7.953C20.53 5.091 18.008 3 15.017 3c-2.254 0-4.244 1.189-5.426 3.003a3.386 3.386 0 0 0-2.212-.826c-1.929 0-3.493 1.637-3.493 3.656 0 .342.045.671.129.986C2.239 10.648 1 12.512 1 14.679 1 17.616 3.275 20 6.082 20h5.077v-4.687H8.4l4.6-5.666 4.6 5.666h-2.76V20h4.176C22.32 20 25 17.194 25 13.734c0-2.605-1.516-4.836-3.675-5.781z" />
  </svg>
);
